module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1515-2fe302988b88767f77717d78d0cdaa55.png";